import { COLOR, CORNERS, FIXED_INDENTS } from 'vars/index'

export const AuthFormBoxDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type AuthFormBoxDirection =
  (typeof AuthFormBoxDirection)[keyof typeof AuthFormBoxDirection]

export const AuthFormBoxJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type AuthFormBoxJustifyContent =
  (typeof AuthFormBoxJustifyContent)[keyof typeof AuthFormBoxJustifyContent]

export const AuthFormBoxAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
} as const
export type AuthFormBoxAlignItems =
  (typeof AuthFormBoxAlignItems)[keyof typeof AuthFormBoxAlignItems]

export const AuthFormBoxBackgroundColors = {
  BACKGROUND_DARK: COLOR.BACKGROUND_DARK,
  TRANSPARENT: COLOR.TRANSPARENT,
} as const
export type AuthFormBoxBackgroundColors =
  (typeof AuthFormBoxBackgroundColors)[keyof typeof AuthFormBoxBackgroundColors]

export const AuthFormBoxRowGaps = {
  SIZE_0: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_10: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_20: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_100,
  ],
  SIZE_30: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
  ],
  SIZE_40: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_50: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_60,
  ],
  SIZE_60: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_60,
  ],
  SIZE_60_0: [FIXED_INDENTS.INDENT_60, FIXED_INDENTS.INDENT_0],
  SIZE_70: [FIXED_INDENTS.INDENT_20, FIXED_INDENTS.INDENT_60],
  SIZE_80: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_90: [
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
  ],
  SIZE_100: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_110: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_120: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_130: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_140: [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_150: [FIXED_INDENTS.INDENT_60, FIXED_INDENTS.INDENT_30],
  SIZE_160: [FIXED_INDENTS.INDENT_60, FIXED_INDENTS.INDENT_60],
  SIZE_170: [
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_180: [
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_190: [
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
  SIZE_200: [
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
  ],
}
export type AuthFormBoxRowGap = readonly FIXED_INDENTS[]

type PaddingKey = 'SIZE_0' | 'SIZE_120' | 'SIZE_140' | 'SIZE_140_100'
export const AuthFormBoxPaddings: Record<
  PaddingKey,
  readonly [string, string, string, string]
> = {
  SIZE_0: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_120: [
    FIXED_INDENTS.INDENT_120,
    FIXED_INDENTS.INDENT_120,
    FIXED_INDENTS.INDENT_120,
    FIXED_INDENTS.INDENT_120,
  ],
  SIZE_140: [
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_140,
  ],
  SIZE_140_100: [
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_100,
    FIXED_INDENTS.INDENT_140,
  ],
} as const

export type AuthFormBoxPadding =
  (typeof AuthFormBoxPaddings)[keyof typeof AuthFormBoxPaddings]

export const AuthFormBoxCorners = {
  CORNERS_0: CORNERS.CORNERS_0,
  CORNERS_10: CORNERS.CORNERS_10,
} as const
export type AuthFormBoxCorners =
  (typeof AuthFormBoxCorners)[keyof typeof AuthFormBoxCorners]
